export default {
  name: 'medicine-detail',
  data: function () {
    return {
      isSelectMode: false,
      searchCallbackFlag: false
    }
  },
  created: function () {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    if (this.$router.currentRoute.query.type == 'select') {
      this.isSelectMode = true;
    }
    this.clearMedicine()
    this.search()
  },
  computed: {
    medicine() {
      return this.$store.getters.medicine
    },
    sideEffects() {
      return this.$store.getters.sideEffects
    },
    /** システム管理者 または 薬剤師 */
    isAdminOrPharmacist() {
      return this.$store.getters.userAdminOrPharmacist
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    notify () {
      return this.$store.getters.medicinesNotify
    }
  },
  methods: {
    search: function() {
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('MEDICINE_DETAIL',  {medicineId: this.$route.params.medicineId, callback: callback})
    },
    clearMedicine: function() {
      this.$store.dispatch('MEDICINE_DETAIL_CLEAR')
    },
    splitText: function(text) {
      return text == null ? '' : text.split('\n')
    },
    goMedicinesEdit: function(medicineId) {
      this.$router.push({ path: '/medicines/' + medicineId + '/edit'})
    },
    backMedicinesList: function() {
      var query = {}
      query['keep'] = 'true'
      if (this.isSelectMode) {
        query['type'] = 'select'
      }
      this.$router.push({ path: '/medicines', query: query})
    },
    getAgeText: function(sideEffect) {
      var ageTexts = []
      if (sideEffect.attributes['age-m-low'] !== null && sideEffect.attributes['age-m-low'] !== null){
        ageTexts.push( this.$t('age',{'age': this.$t('Male') + '：' + sideEffect.attributes['age-m-low'] + '～' + sideEffect.attributes['age-m-high']} ) )
      }
      if (sideEffect.attributes['age-f-low'] !== null && sideEffect.attributes['age-f-low'] !== null){
        ageTexts.push( this.$t('age',{'age': this.$t('Female') + '：' + sideEffect.attributes['age-f-low'] + '～' + sideEffect.attributes['age-f-high']}) )
      }
      return ageTexts.length > 0 ? '（' + ageTexts.join('、') + '）' : ''
    },
    sendDataToReport: function(sideEffect, mode) {
      if (window.opener || Object.keys(window.opener).length > 0) {
        window.opener.sendMedicinesData(this.selectFormat(sideEffect, mode))
        window.open('about:blank','_self').close() // 画面を閉じる
      }
    },
    selectFormat: function(sideEffect, mode) {
      var category = sideEffect.attributes['category']

      var medicineName = '「' +this.medicine.attributes['medicine-name']+ '」'
      var comment = '「' + sideEffect.attributes['comment'] + this.getAgeText(sideEffect) + '」'
      var connectionWord = category == 'serious' ? this.$t('side_effect.connection.serious') : this.$t('side_effect.connection.other')
      var endWord = ''

      if ( category == 'serious') {
        if (mode == 'confirmed') {
          endWord = this.$t('side_effect.end_word.serious.confirmed')
        } else {
          endWord = this.$t('side_effect.end_word.serious.explain')
        }
      } else {
        if (mode == 'confirmed') {
          endWord = this.$t('side_effect.end_word.other.confirmed')
        } else {
          endWord = this.$t('side_effect.end_word.other.explain')
        }
      }

      return medicineName + connectionWord + comment + endWord
    },
    sendMedicineToReport: function(medicine) {
      if (window.opener || Object.keys(window.opener).length > 0) {
        window.opener.sendMedicinesData(this.medicineFormat(medicine))
        // Chrome対応 画面を閉じる
        if (/Chrome/i.test(navigator.userAgent)) {
          window.close()
        } else {
          window.open('about:blank', '_self').close()
        }
      }
    },
    medicineFormat: function(medicine) {
      var medicineName = '「' + medicine['medicine-name'] + '」'
      var comment = '「' + medicine['intro-text'] + '」'
      var connectionWord = this.$t('side_effect.connection.medicine')
      var endWord = this.$t('side_effect.end_word.other.explain')

      return medicineName + connectionWord + comment + endWord
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/medicine-detail.js